import { colors } from "@chhjit/react-components";
import { makeStyles, Theme } from "@material-ui/core";

export const useTileCardStyles = makeStyles((theme: Theme) => ({
  selectLabel: {
    marginBottom: 4,
  },

  root: {
    padding: 32,
    border: `2px solid ${colors.grey40}`,
    borderRadius: 4,
    backgroundColor: colors.basic.white,
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    cursor: "pointer",
    width: "100%",
    height: "100%",
    color: "inherit",

    "&:hover": {
      borderColor: colors.primary.main,
    },
  },

  horizontal: {
    flexDirection: "row",
    justifyContent: "space-between",
    gap: 16,
    padding: "16px 32px",

    "& $labelAndCheckbox": {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "flex-start",
      order: 1,
    },

    "& $checkbox": {
      marginRight: 7,
      marginLeft: -9,
    },

    "& $label": {
      fontSize: 18,
      textAlign: "left",
    },

    "& $icon": {
      order: 2,
    },
  },

  vertical: {
    "& $label": {
      fontSize: 32,
      order: 1,
    },

    "& $checkbox": {
      order: 2,
    },

    "& $icon": {
      marginBottom: 8,
    },
  },

  verticalCompact: {
    padding: 16,

    "& $label": {
      fontSize: 20,
    },

    "& $icon": {
      width: 48,
      height: 48,

      "& svg": {
        fontSize: "48px !important",
      },
    },
  },

  selected: {
    borderColor: colors.primary.main,
    backgroundColor: colors.primary.superlight,
    color: colors.secondary.main,
  },

  labelAndCheckbox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexDirection: "column",
    order: 2,
    flex: 1,
    height: "100%",
    // maxWidth: "100%",
  },

  checkbox: {
    marginRight: 0,
    marginLeft: 0,
    order: 1,
  },

  label: {
    order: 2,
    fontSize: 32,
    textAlign: "center",
    color: "inherit",
    lineHeight: "initial",
    height: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    wordBreak: "break-word",
    whiteSpace: "break-spaces",
  },

  icon: {
    order: 1,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 80,
    height: 80,

    "& svg": {
      fontSize: "80px !important",
    },

    [theme.breakpoints.down("xs")]: {
      width: 64,
      height: 64,

      "& svg": {
        fontSize: "64px !important",
      },
    },
  },
}));
